export default {
  listaUnidadeMedidas: [],
  colunas: [
    {
      text: 'siglaSimbolo',
      align: 'start',
      sortable: false,
      value: 'sigla',
      width: '120px',
    },
    {
      text: 'descricao',
      align: 'start',
      sortable: false,
      value: 'descricao',
    },
    {
      text: 'actions',
      align: 'start',
      sortable: false,
      value: 'actions',
      width: '150px',
    },
  ],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    sigla: '',
    descricao: '',
    order: 'descricao',
    direcao: '',
  },
  colDefault: 'sigla',
  directionDefault: '',
  campos: {
    sigla: 'sigla',
    descricao: 'descricao',
  },
  unidadesMedida: [],
};
